import DomainResource from './DomainResource';
import merge from 'lodash/merge';

/**
 * The account's vitals settings, stored at the fixed id `vitals`. Holds only the change set
 * from the catalog in client/src/common/vitalsConstants.js: default vitals switched off
 * (`hiddenDefaults`) and optional vitals switched on (`enabledOptionals`), as vital keys.
 */
export default class BN_VitalsConfig extends DomainResource {
    static _className = 'BN_VitalsConfig';

    _objectStructure = {
        hiddenDefaults: [String],
        enabledOptionals: [String],
    };

    constructor(constructJson, className = 'BN_VitalsConfig') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
